import axios from 'axios';
import { message } from 'antd';
import {
  CATALOG_API
} from '../../../constants/API';
import {
  UNSUBSCRIBE_CATALOG_LOADING,
} from '../types';

function unsubscribeCatalog(catalogId) {
  return async (dispatch, getState) => {
    dispatch({
      type: UNSUBSCRIBE_CATALOG_LOADING,
      unsubscribingCatalog: true
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const { userData } = getState().AuthReducer;
      const postData = {
        catalogId,
        userId: userData.id
      };
      await axios.post(
        `${CATALOG_API}/unsubscribe`,
        postData,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      dispatch({
        type: UNSUBSCRIBE_CATALOG_LOADING,
        unsubscribingCatalog: false
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: UNSUBSCRIBE_CATALOG_LOADING,
        unsubscribingCatalog: false
      });
    }
  };
}
export default unsubscribeCatalog;
